export const PAYERS_LEGACY_FORCED = [
  {
    payer: 'Cigna',
    states: [],
    legacyPayerName: 'Cigna',
  },
  {
    payer: 'Humana',
    states: [],
    legacyPayerName: 'Humana',
  },
];